import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type dashboardPermissionType = 'dashboard_view';

export const dashboardPermissionMatrix: IPermissionMatrix<dashboardPermissionType> = {
  dashboard_view: [UserRole.user]
};
